// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"6ba86818","667":"9b927bab"}[chunkId] + ".js";
};